module.exports = __webpack_public_path__ + "static/img/medicals.08049f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medicals.png
// module id = kg8c
// module chunks = 1